module.exports = __webpack_public_path__ + "img/yy2.bf7d731a.png";